/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, TemplateRef } from '@angular/core';
import { IRowNode } from 'ag-grid-community';
import { GridRowInitParams, GridRowParams } from '../option-bar/grid-row-options-component';

import { GridRowSelectionsComponent } from './grid-row-selections-component';

@Component({
  standalone: false,
  selector: 'gh-template-based-select-bar',
  template: `
    <ng-container [ngTemplateOutlet]='templateRef'
                  [ngTemplateOutletContext]='{ $implicit: node.data, node: node }'></ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTemplateBasedSelectBarComponent implements GridRowSelectionsComponent {
  templateRef: TemplateRef<any>;
  node: IRowNode;

  constructor(private changeDetectorRef: ChangeDetectorRef) {

  }

  setTemplateRef(templateRef: TemplateRef<any>): void {
    this.templateRef = templateRef;
  }

  initRowOptions(row: GridRowInitParams): void {
    this.node = row.node;

    this.changeDetectorRef.detectChanges();
  }

  refresh(row: GridRowParams): void {
    this.node = row.node;

    this.changeDetectorRef.markForCheck();
  }
}
